/** Fixed board decision options (not tied to parametrage settings). */
export const BOARD_DECISION_PRESETS = [
  { id: 1, name: "يرتقي", nameF: "ترتقي" },
  {
    id: 2,
    name: "يرتقي بالإسعاف",
    nameF: "ترتقي بالإسعاف",
  },
  {
    id: 3,
    name: "يرتقي بالإسعاف العمري",
    nameF: "ترتقي بالإسعاف العمري",
  },
  {
    id: 4,
    name: "يرتقي باستحقاق",
    nameF: "ترتقي باستحقاق",
  },
  { id: 5, name: "يرسب", nameF: "ترسب" },
];

export const presetOptionLabel = (p) => `${p.name} / ${p.nameF}`;

export const pickPresetForGender = (preset, gender) =>
  gender === "female" ? preset.nameF || preset.name : preset.name;

export const PRESET_TO_KEY = { 1: "A", 2: "C", 3: "P", 4: "A", 5: "R" };

export const PRESET_DECISON_ON = { 1: "A", 2: "C", 3: "P", 4: "A", 5: "R" };

export const PV_DECISION_KEYS = ["A", "C", "P", "R"];

/** Arabic labels for PV keys — always shown in UI regardless of app locale. */
export const PV_DECISION_KEY_LABELS_AR = {
  A: "الارتقاء",
  C: "الارتقاء بالإسعاف",
  P: "الارتقاء بالإسعاف العمري",
  R: "يرسب",
};

export const pvDecisionKeyLabel = (key) =>
  PV_DECISION_KEY_LABELS_AR[key] || "—";

export const PV_DECISION_KEY_OPTIONS = PV_DECISION_KEYS.map((value) => ({
  value,
  label: PV_DECISION_KEY_LABELS_AR[value],
}));

export const isValidPvDecisionKey = (key) => PV_DECISION_KEYS.includes(key);

/** Align parametrage rows with server-side getStoredDecisionConseilParams. */
export const normalizeDecisionParams = (stored) => {
  if (!Array.isArray(stored)) return [];
  return stored.map((row) => {
    const id = Number(row.id ?? row.key);
    let decisonOn = row.decisonOn || PRESET_DECISON_ON[id];
    if (id === 3 && decisonOn === "C") decisonOn = "P";
    return { ...row, id: row.id ?? row.key, decisonOn };
  });
};

export const getKeyFromDecisionParams = (params, finalMoyenne) => {
  if (finalMoyenne == null || finalMoyenne === "" || finalMoyenne === "--") {
    return "--";
  }
  const moy = Number(finalMoyenne);
  if (Number.isNaN(moy)) return "--";
  for (const d of params || []) {
    if (moy >= Number(d.min) && moy <= Number(d.max)) {
      const rowId = Number(d.id ?? d.key);
      let key = d.decisonOn || PRESET_TO_KEY[rowId] || "--";
      if (rowId === 3 && key === "C") key = "P";
      return key;
    }
  }
  return "--";
};
